<template>
  <NuxtLayout>
    <div class="page-index">
<!--      <piaochuang />-->
      <div
        v-for="element in componentList"
        :key="element.id"
        class="component_layout"
      >
        <new-index-banner
          v-if="element.type === 'banner'"
          :component-info="element"
        />
        <new-index-course
          v-if="element.type === 'course'"
          :component-info="element"
        />
        <new-index-grade
          v-if="element.type === 'grade'"
          :component-info="element"
        />
        <new-index-teacher
          v-if="element.type === 'teacher'"
          :component-info="element"
        />
        <new-index-news
          v-if="element.type === 'news'"
          :component-info="element"
        />
        <new-index-ad
          v-if="element.type === 'ad'"
          :component-info="element"
        />
        <index-patch-ad
          v-if="element.type === 'patchAd'"
          :component-info="element"
        />
        <!--        <index-exam-prac-->
        <!--          v-if="element.type === 'examPrac'"-->
        <!--          :component-info="element"-->
        <!--        />-->
      </div>


      <!--      <video id="videoDom" controls="controls" class="video-view">-->
      <!--        <source type="video/mp4" src="@/assets/video/start.mp4">-->
      <!--      </video>-->
    </div>



  </NuxtLayout>
</template>
<script setup>
import { getComponentList, getComponentData } from '@/api/layouts'
import cookie from '@/utils/cookies'
import config from '~/config'
import { shopDataInfo, testDebug } from '../../api/system'
// import piaochuang from "@/components/piaochuang/index.vue";
const { data: shopData } = await useAsyncData('course', async (ctx) => {
  let url = ''
  if (process.server) {
    url = ctx.ssrContext?.event?.req?.headers?.host
  } else {
    url = window.location.host
  }
  if (config.url) {
    url = config.url
  }
  return await shopDataInfo({ domain: url })
})

const cookieData = cookie.getShop()
const componentList1 = ref([])
const teacherValue = ref({})
const grade = ref({})

useHead({
  meta: [{ charset: 'utf-8' }, {
    hid: 'keywords',
    name: 'keywords',
    content: shopData.value.keywords || cookieData.shopName
  },
    {
      hid: 'description',
      name: 'description',
      content: shopData.value.shopIntroduce || cookieData.shopName
    }],
  title: computed(() => `${cookieData.shopName}`)
})

const opts = reactive({
  componentEnum: {
    1: { name: 'banner', listName: 'detailList' },
    2: { name: 'course', listName: 'courseList' },
    3: { name: 'grade', listName: 'classroomList' },
    4: { name: 'teacher', listName: 'teacherList' },
    5: { name: 'news', listName: 'articleList' },
    6: { name: 'ad', listName: 'detailList' },
    7: { name: 'patchAd', listName: 'detailList' },
    9: { name: 'examPrac', listName: 'dailyPracticeList' }
  }
})
const componentList = ref([])
const getTemplate = async () => {
  const result = await getComponentList()
  componentList.value = []
  result.forEach((item) => {
    const c = opts.componentEnum[item.componentType]
    if (c && c.name) {
      const cp = {
        type: c.name,
        id: item.id,
        componentType: item.componentType,
        config: item,
        data: []
      }
      componentList.value.push(cp)
    }
  })
  let count = 0
  return new Promise((resolve) => {
    componentList.value.forEach(async (item) => {
      try {
        const res = await getComponentData({ id: item.id })
        if (item.componentType === 9) {
          item.data = [
            ...res.chapterPracticeList,
            ...res.dailyPracticeList,
            ...res.paperExamList,
            ...res.passPracticeList
          ]
        } else {
          item.data = res[opts.componentEnum[item.componentType].listName] || []
        }

        item.navList = res.navList || []
        if (item.componentType == 4) {
          teacherValue.value = item
        }
        if (item.componentType == 3) {
          grade.value = item
        }
      } catch (err) {
      }
      count++
      if (count === componentList.value.length) {
        resolve(componentList.value)
      }
    })
    componentList1.value = componentList
  })
}

onMounted(() => {
  getTemplate()
})
</script>
<style lang="scss" scoped>

</style>
